import {EXPAND_MODE_EXPANDED} from '../components/List/ExpandAllButton.js'

export const TRANSFER_DATE_CREATED = 'created'
export const TRANSFER_DATE_UPDATED = 'updated'
export const TRANSFER_DEFAULT_DATE_TYPE = TRANSFER_DATE_CREATED

export const TRANSFER_DATE_FILTERS = [
  TRANSFER_DATE_CREATED,
  TRANSFER_DATE_UPDATED,
]

export const TRANSFER_DATE_FILTERS_OPTIONS = [
  {
    value: TRANSFER_DATE_CREATED,
    display: 'Created Date',
  },
  {
    value: TRANSFER_DATE_UPDATED,
    display: 'Updated Date',
  },
]

export const TRANSFER_API_DATE_FILTERS = TRANSFER_DATE_FILTERS.reduce(
  (prev, dateType) =>
    prev.push(
      ...[
        `${dateType}_after`,
        `${dateType}_before`,
        `${dateType}_interval_type`,
        `${dateType}_interval_amount`,
        `${dateType}_interval_trunc`,
      ],
    ) && prev,
  [],
)

export const TRANSFER_SORT_OPTIONS = [
  {value: `-${TRANSFER_DATE_CREATED}`, display: 'Date Created (Newest)'},
  {value: TRANSFER_DATE_CREATED, display: 'Date Created (Oldest)'},
  {value: `-${TRANSFER_DATE_UPDATED}`, display: 'Date Updated (Newest)'},
  {value: TRANSFER_DATE_UPDATED, display: 'Date Updated (Oldest)'},
]

export const DEFAULT_EXPAND_MODE = EXPAND_MODE_EXPANDED
export const DEFAULT_SORT = `-${TRANSFER_DATE_UPDATED}`
export const DEFAULT_PER_PAGE = 10

export const TRANSFER_URI_COMPONENT = 'inventory_transfer'
